import Reveal from "@/components/site/Reveal";

const POINTS = [
  ["CUT TO YOUR SIZE", "Sheets and plates sheared, sections cut to length at the yard. No wastage billed to you."],
  ["YARD IN LOHA MANDI", "Inspect before you load — what you see is what you get."],
  ["DAILY MILL RATES", "You get today's number, not last week's."],
];

export default function WhyUs() {
  return (
    <section className="section-paper why-us" data-testid="why-us-section">
      <Reveal>
        <div className="section-head">
          <span className="mono-tag">03 / WHY AHUJA BROTHERS<sup>®</sup></span>
          <h2 className="section-title">STRAIGHT FROM THE YARD</h2>
        </div>
      </Reveal>

      <Reveal delay={0.1}>
      <div className="why-list">
        {POINTS.map(([title, body], i) => (
          <div className="why-row" key={title} data-testid={`why-row-${i + 1}`}>
            <span className="why-num mono-tag">{String(i + 1).padStart(2, "0")}</span>
            <div>
              <h3 className="why-title">{title}</h3>
              <p className="why-body">{body}</p>
            </div>
          </div>
        ))}
      </div>
      </Reveal>
    </section>
  );
}
